'use strict';/* global define */define('modules/custom-forms/states/team_form-builder_editor/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "$state", "CustomBuilderFormConfig"];
function controller($scope,$state,CustomBuilderFormConfig){// jshint validthis:true
// jshint latedef:false
var ctrl=this;$scope.$on('$destroy',destroy);$scope.$on('$stateChangeSuccess',function(event,toState){if(toState.name==='app.team.formBuilder.editor.edit'||toState.name==='app.team.formBuilder.editor.assign'){_setStateConfig();}});// ---
/**
     * Set config properties on success change state event
     *
     * @private
     */function _setStateConfig(){var currentChildState=$state.current.name.split('.');ctrl.currentChildState=currentChildState[currentChildState.length-1];ctrl.isNew=!$state.params.id;}/**
     * Execute clean up on scope destroy
     *
     * - clean up the cache for forms config
     */function destroy(){CustomBuilderFormConfig.flush();}}module.exports=controller;});
